import axios from "axios";
import { Text } from "components";

import React, { forwardRef, useEffect, useRef, useState } from "react";
import Select from "react-select";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver"; // Install file-saver if you don't have it: npm install file-saver

import {
  Bar,
  BarChart,
  CartesianGrid,
  LabelList,
  Legend,
  ReferenceLine,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { toast, ToastContainer } from "react-toastify";
import { formatRupee } from "utils/helpingMethods/formatRupee";
import CustomSelect from "components/SmallComponents/CustomSelect";

const CategoryWiseSupplierSalesReport = forwardRef((props, ref) => {
  const [download, setDownload] = useState(false);
  const gridRef = useRef();
  const [flag, setFlag] = useState(false);

  const today = new Date();
  const formattedToday = today.toISOString().split("T")[0];
  const thirtyDaysAgo = new Date(today);
  thirtyDaysAgo.setDate(1); // Set to the first day of the current month
  thirtyDaysAgo.setMonth(thirtyDaysAgo.getMonth() - 2); // Go back one month
  // const formattedThirtyDaysAgo = thirtyDaysAgo.toISOString().split('T')[0];
  const firstDayOfCurrentMonth = new Date(
    today.getFullYear(),
    today.getMonth(),
    1
  );
  const formattedThirtyDaysAgo = `${firstDayOfCurrentMonth.getFullYear()}-${String(
    firstDayOfCurrentMonth.getMonth() + 1
  ).padStart(2, "0")}-01`;

  const [timedateflag, setTimeDateFlag] = useState(false);
  const [revenuedata, setRevenueData] = useState([]);
  const [categoryWiseRevenueData, setCategoryWiseRevenueData] = useState([]);
  const [revenuedataforExcel, setRevenueDataForExcel] = useState([]);
  const [supplierId, setSupplierId] = useState();
  const [itemCategoryId, setItemCategoryId] = useState();
  const [itemCategoryName, setItemCategoryName] = useState("For all Category");
  const [supplierName, setSupplierName] = useState("For all Supplier");
  const [supplierList, setSupplierList] = useState([]);
  const [itemCategoryList, setItemCategoryList] = useState([]);

  const [toDate, setToDate] = useState(formattedToday);
  const [fromDate, setFromDate] = useState(formattedThirtyDaysAgo);
  const [showChart, setShowChart] = useState(false);
  const token = sessionStorage.getItem("token");
  const headers = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  // Subtract one year
  today.setFullYear(today.getFullYear() - 1);
  const oneYearPreviousDate = today.toISOString().split("T")[0];

  // Monthwise  revenue data get...for bar chart
  // for getting revenue data from tax invoice...
  useEffect(() => {
    setTimeout(() => {
      revenueCategoryWiseDataGet();
    }, 1000);
  }, [fromDate, toDate, supplierId, itemCategoryId]);

  const obj = {
    start_date: fromDate,
    end_date: toDate,
    supplier_id: supplierId,
    item_category_id: itemCategoryId,
  };

  const revenueCategoryWiseDataGet = () => {
    axios
      .post(
        "/api/purple-fusion/revenuereport/supplier/get/byCategoryId",
        obj,
        headers
      )
      .then((response) => {
        const sortedData = response.data.sort(
          (a, b) => b.total_amount - a.total_amount
        );
        setRevenueData(sortedData);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  //for excel...
  useEffect(() => {
    setTimeout(() => {
      revenueDataGetForExcel();
    }, 1500);
  }, [fromDate, toDate, supplierId, itemCategoryId]);

  const obj_for_excel = {
    start_date: fromDate,
    end_date: toDate,
    supplier_id: supplierId,
    item_category_id: itemCategoryId,
  };
  //for excel...
  const revenueDataGetForExcel = () => {
    axios
      .post(
        "/api/purple-fusion/revenuereport/supplier/get/categoryWise/exceldata",
        obj_for_excel,
        headers
      )
      .then((response) => {
        const rawData = response.data;
        console.log("Excel Data:", rawData);
        setRevenueDataForExcel(response.data);
        // Group and sum total_amount by item_category_name
        const groupedData = Object.values(
          rawData.reduce((acc, item) => {
            const category = item.item_category_name;
            const amount = parseFloat(item.total_amount) || 0;

            if (!acc[category]) {
              acc[category] = {
                item_category_name: category,
                total_amount: 0,
              };
            }

            acc[category].total_amount += amount;

            return acc;
          }, {})
        );
        console.table(groupedData);
        setCategoryWiseRevenueData(
          groupedData.sort((a, b) => b.total_amount - a.total_amount)
        );
      })
      .catch((error) => {
        console.log(error);
      });
  };

  //for getting custumer list ....
  useEffect(() => {
    getSupplierList();
  }, []);

  const getSupplierList = () => {
    axios
      .post(
        "/api/purple-fusion/companypurchaseorderreport/get/supplier",
        {},
        headers
      )
      .then((response) => {
        setSupplierList(response.data);
        // console.log(response.data);
      })
      .catch((error) => {
        console.error("Error in fetching company purchase items", error);
      });
  };

  //for getting Item Category List ....
  useEffect(() => {
    getItemCategoryList();
  }, []);

  const getItemCategoryList = () => {
    axios
      .post("/api/purple-fusion/itemcategory/get", {}, headers)
      .then((response) => {
        setItemCategoryList(response.data);
        console.log(response.data);
      })
      .catch((error) => {
        console.error("Error in fetching company purchase items", error);
      });
  };

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div
          className="custom-tooltip"
          style={{
            backgroundColor: "white",
            padding: "5px",
            border: "1px solid #ccc",
          }}
        >
          {/* Rounding the value to 2 decimal places */}
          <p>{`Total Sales: ${formatRupee(payload[0].value)}`}</p>
        </div>
      );
    }
    return null;
  };

  const DownloadExcel = () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Category-Wise Purchase Report");

    // Helper function to format headers date
    const formatHeadersDate = (dateStr) => {
      const [year, month, day] = dateStr.split("-");
      return `${day}-${month}-${year}`;
    };
    // Add report title and date range at the top
    worksheet.addRow(["Report Name:", "Category-Wise Sales Report"]);
    worksheet.addRow(["Category Type:", itemCategoryName]); // Add Category row here
    worksheet.addRow([
      "From Date:",
      fromDate ? formatHeadersDate(fromDate) : "",
    ]);
    worksheet.addRow(["To Date:", toDate ? formatHeadersDate(toDate) : ""]);
    worksheet.addRow(["Supplier Name:", supplierName]);

    worksheet.addRow([]); // Empty row for spacing

    // Define headers with 'SR.NO', 'Customer Name', and unique item categories
    const uniqueSuppliers = Array.from(
      new Set(revenuedataforExcel.map((data) => data.supplier_name))
    );
    const uniqueItemCategories = Array.from(
      new Set(revenuedataforExcel.map((data) => data.item_category_name))
    );

    const headers = [
      "Sr.No",
      "Supplier Name",
      ...uniqueItemCategories,
      "Total", // Add the 'Total' column header
    ];
    worksheet.addRow(headers);

    // Freeze the top 6 rows (title and header)
    worksheet.views = [{ state: "frozen", ySplit: 7 }];

    // Apply bold font and left alignment to the first 5 rows of column 1
    for (let i = 1; i <= 5; i++) {
      const cell = worksheet.getCell(i, 1);
      cell.font = { bold: true };
    }
    // Remove gridlines for the first 5 rows by setting the fill to match the background
    for (let i = 1; i <= 6; i++) {
      for (let j = 1; j <= headers.length; j++) {
        const cell = worksheet.getRow(i).getCell(j);
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFFFFFFF" }, // white background
        };
      }
    }

    // Add styles to the header row (7th row)
    worksheet.getRow(7).eachCell({ includeEmpty: true }, (cell) => {
      cell.font = { bold: true, color: { argb: "FFFFFFFF" } }; // white text color
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FF368BC1" }, // blue background color
      };
      cell.alignment = { horizontal: "center", vertical: "middle" };
    });

    // Populate data with a total for each customer row
    uniqueSuppliers.forEach((supplierName, supplierIndex) => {
      const row = [supplierIndex + 1, supplierName];
      let rowTotal = 0;

      uniqueItemCategories.forEach((category) => {
        const totalAmount = revenuedataforExcel
          .filter(
            (data) =>
              data.supplier_name === supplierName &&
              data.item_category_name === category
          )
          .reduce((acc, data) => acc + Number(data.total_amount), 0);

        const roundedAmount = Math.round(totalAmount * 100) / 100;
        row.push(roundedAmount);
        rowTotal += roundedAmount;
      });

      row.push(rowTotal);
      worksheet.addRow(row);
    });

    // Set the number format for columns with amounts
    worksheet.eachRow((row, rowNumber) => {
      row.eachCell((cell, colNumber) => {
        if (colNumber > 2) {
          cell.numFmt = "0.00";
        }
      });
    });
    // Apply left alignment to columns A and B
    worksheet.getColumn(1).alignment = { horizontal: "left" };
    worksheet.getColumn(2).alignment = { horizontal: "left" };

    // Apply right alignment to the remaining data columns
    for (let i = 4; i <= worksheet.columns.length; i++) {
      worksheet.getColumn(i).alignment = { horizontal: "right" };
    }

    // Save the workbook
    workbook.xlsx.writeBuffer().then((buffer) => {
      saveAs(
        new Blob([buffer]),
        `Category-Wise Purchase Report ${new Date()
          .toISOString()
          .slice(0, 10)}.xlsx`
      );
    });
  };

  const [dateTime, setDateTime] = useState("");
  useEffect(() => {
    const currentTimestamp = new Date();
    const formattedDate = currentTimestamp
      .toLocaleDateString([], {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .replace(/\//g, "-");
    const formattedDateTime = `${formattedDate}`;
    setDateTime(formattedDateTime);
  }, [timedateflag]);

  //for reset input filed...
  const [resetkey, setResetKey] = useState(0);
  useEffect(() => {
    setResetKey((prev) => prev + 1);
  }, [toDate, fromDate]);

  // Function to convert amount to lakhs
  const formatToLakhs = (amount) => {
    if (amount >= 100000 || amount >= 0) {
      return (amount / 100000).toFixed(2);
    }
    return amount.toFixed(2);
  };
  // Validate "To" date when it changes
  const validateToDate = (newToDate) => {
    if (fromDate) {
      const from = new Date(fromDate);
      const maxToDate = new Date(from.setDate(from.getDate() + 366))
        .toISOString()
        .split("T")[0];

      if (newToDate > maxToDate) {
        toast.error(
          'The "To" date must be within 366 days after the "From" date.'
        );
        setToDate(maxToDate); // Reset to maximum allowed date
      } else {
        setToDate(newToDate);
      }
    }
  };

  //for consider max value in graph
  const maxValue = Math.max(...revenuedata.map((data) => data.total_amount));
  const maxValueforcategory = Math.max(
    ...categoryWiseRevenueData.map((data) => data.total_amount)
  );
  return (
    <>
      <ToastContainer />
      <div className="w-full flex flex-col">
        <div className="flex justify-between items-start my-1 mx-3 gap-1">
          <div className="flex flex-row items-center w-full">
            <Text className="text-sm md:text-[22px] text-gray-600 sm:text-xl pt-2 mr-2 ml-2 mb-2">
              From
            </Text>
            <input
              name="from_date"
              type="date"
              value={fromDate}
              // onChange={(e) => setFromDate(e.target.value)}
              onChange={(e) => {
                setFromDate(e.target.value);
                validateToDate(toDate); // Validate "To" date whenever "From" date changes
              }}
              className="bg-white-A700 border border-gray-400_02 border-solid h-9 rounded-[5px] text-sm"
            />
            <Text className="text-sm md:text-[22px] text-gray-600 sm:text-xl pt-2 mr-2 ml-2 mb-2">
              To
            </Text>
            <input
              name="to_date"
              type="date"
              value={toDate}
              // onChange={(e) => setToDate(e.target.value)}
              onChange={(e) => validateToDate(e.target.value)}
              className="bg-white-A700 border border-gray-400_02 border-solid h-9 rounded-[5px] text-sm"
            />
            <CustomSelect
              options={[
                { label: "All Supplier", value: "" },
                ...supplierList.map((supplier) => ({
                  label: supplier.name,
                  value: supplier.id,
                })),
              ]}
              className="bg-white-A700 border border-gray-200_02 border-solid h-9 ml-2 rounded-md w-[20%] text-sm "
              onChange={(selectedOption) => {
                setSupplierId(selectedOption.value);
                setShowChart(true);
                setSupplierName(selectedOption.label);
                setFlag(true);
              }}
              placeholder="All Supplier"
              key={resetkey}
            />
            <CustomSelect
              options={[
                { label: "All Category", value: "" },
                ...itemCategoryList.map((itemCategory) => ({
                  label: itemCategory.name,
                  value: itemCategory.id,
                })),
              ]}
              className="bg-white-A700 border border-gray-200_02 border-solid h-9 ml-2 rounded-md w-[20%] text-sm "
              onChange={(selectedOption) => {
                setItemCategoryId(selectedOption.value);
                setItemCategoryName(selectedOption.label);
                setShowChart(true);
              }}
              placeholder="All Category"
              // key={resetkey}
            />
          </div>
          <div className="flex items-center">
            <div
              className="flex flex-col relative z-20 "
              onMouseEnter={() => setDownload(true)}
              onMouseLeave={() => setDownload(false)}
            >
              <button
                id="dropdownDefaultButton"
                data-dropdown-toggle="dropdown"
                className="text-white-A700 bg-blue-700 hover:bg-blue-800 font-medium rounded-lg text-sm px-3 py-1.5 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 w-28 mr-4 "
                type="button"
              >
                {"Download"} &nbsp;
                <svg
                  className="w-2.5 h-2.5 ms-3"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 10 6"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m1 1 4 4 4-4"
                  />
                </svg>
              </button>
              <div
                className={`${
                  download ? "absolute top-[32px]" : "hidden"
                } z-20 bg-white divide-y divide-gray-100 rounded-lg shadow w-[110px] bg-white-A700  dark:bg-gray-700`}
              >
                <ul
                  className="py-0 text-sm text-gray-700 dark:text-gray-200"
                  aria-labelledby="dropdownDefaultButton"
                >
                  <li>
                    <span
                      className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                      onClick={() => DownloadExcel()}
                    >
                      Excel
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        {revenuedata.length > 0 && (
          <div className="w-full flex flex-row p-2 m-1 gap-4 h-full">
            <div className="flex-1 relative border-2 shadow-md rounded-md">
              <div className="absolute top-2 right-4 font-semibold text-sm text-gray-800 ">
                Total Purchase: ₹
                {revenuedata
                  .reduce(
                    (sum, item) => sum + Number(item.total_amount || 0),
                    0
                  )
                  .toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
              </div>
              <ResponsiveContainer width="100%" height={400}>
                <BarChart
                  layout="vertical"
                  data={revenuedata}
                  margin={{ top: 50, right: 100, bottom: 5, left: 20 }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <Legend
                    verticalAlign="bottom"
                    wrapperStyle={{ fontSize: "12px" }}
                  />
                  <ReferenceLine x={0} stroke="#000" />
                  <XAxis
                    type="number"
                    domain={[0, maxValue * 1.1]} // Set domain to fit data with some padding (10%)
                    tickFormatter={(value) => {
                      if (value >= 1000000) {
                        return `${(value / 1000000).toFixed(1)}M`;
                      } else if (value >= 100000) {
                        return `${(value / 100000).toFixed(1)}L`;
                      } else if (value >= 1000) {
                        return `${(value / 1000).toFixed(1)}K`;
                      } else {
                        return value.toFixed(0);
                      }
                    }}
                    tick={{ fontSize: "12px" }}
                  />
                  <YAxis
                    type="category"
                    dataKey="month_name"
                    tickFormatter={(month) => month.slice(0, 3)}
                    tick={{ fontSize: "12px" }}
                  />
                  <Tooltip
                    content={<CustomTooltip />}
                    wrapperStyle={{ fontSize: "12px" }}
                  />
                  <Bar
                    dataKey="total_amount"
                    name="Amount"
                    fill="#2196F3"
                    barSize={40}
                    isAnimationActive={true}
                    animationDuration={500}
                  >
                    <LabelList
                      dataKey="total_amount"
                      position="right"
                      content={({ x, y, width, height, value }) => {
                        const total = revenuedata.reduce(
                          (sum, item) => sum + Number(item.total_amount),
                          0
                        );
                        const numericValue = Number(value);
                        const percentage = total
                          ? ((numericValue / total) * 100).toFixed(1)
                          : 0;
                        return (
                          <text
                            x={x + width + 5} // position slightly right of the bar
                            y={y + height / 2}
                            fill="#000"
                            fontSize="12"
                            alignmentBaseline="middle"
                          >
                            {`${formatRupee(numericValue)} (${percentage}%)`}
                          </text>
                        );
                      }}
                    />
                  </Bar>
                </BarChart>
              </ResponsiveContainer>
            </div>

            <div className="flex-1 relative border-2 shadow-md rounded-md">
              <div className="absolute top-2 right-4 font-semibold text-sm text-gray-800 ">
                Total Purchase: ₹
                {categoryWiseRevenueData
                  .reduce(
                    (sum, item) => sum + Number(item.total_amount || 0),
                    0
                  )
                  .toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
              </div>
              <ResponsiveContainer width="100%" height={400}>
                <BarChart
                  layout="vertical"
                  data={categoryWiseRevenueData}
                  margin={{ top: 50, right: 100, bottom: 5, left: 20 }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <Legend
                    verticalAlign="bottom"
                    wrapperStyle={{ fontSize: "12px" }}
                  />
                  <ReferenceLine x={0} stroke="#000" />
                  <XAxis
                    type="number"
                    domain={[0, maxValueforcategory * 1.1]} // Set domain to fit data with some padding (10%)
                    tickFormatter={(value) => {
                      if (value >= 1000000) {
                        return `${(value / 1000000).toFixed(1)}M`;
                      } else if (value >= 100000) {
                        return `${(value / 100000).toFixed(1)}L`;
                      } else if (value >= 1000) {
                        return `${(value / 1000).toFixed(1)}K`;
                      } else {
                        return value.toFixed(0);
                      }
                    }}
                    tick={{ fontSize: "12px" }}
                  />
                  <YAxis
                    type="category"
                    dataKey="item_category_name"
                    tickFormatter={(month) => month.slice(0, 3)}
                    tick={{ fontSize: "12px" }}
                  />
                  <Tooltip
                    content={<CustomTooltip />}
                    wrapperStyle={{ fontSize: "12px" }}
                  />
                  <Bar
                    dataKey="total_amount"
                    name="Amount"
                    fill="#2196F3"
                    barSize={40}
                    isAnimationActive={true}
                    animationDuration={500}
                  >
                    <LabelList
                      dataKey="total_amount"
                      position="right"
                      content={({ x, y, width, height, value }) => {
                        const total = categoryWiseRevenueData.reduce(
                          (sum, item) => sum + Number(item.total_amount),
                          0
                        );
                        const numericValue = Number(value);
                        const percentage = total
                          ? ((numericValue / total) * 100).toFixed(1)
                          : 0;
                        return (
                          <text
                            x={x + width + 5} // position slightly right of the bar
                            y={y + height / 2}
                            fill="#000"
                            fontSize="12"
                            alignmentBaseline="middle"
                          >
                            {`${formatRupee(numericValue)} (${percentage}%)`}
                          </text>
                        );
                      }}
                    />
                  </Bar>
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>
        )}
        {/* for card to say please select items */}
        {revenuedata.length == 0 && (
          <div className="w-[96%] h-full flex justify-center items-center m-4 p-6 border-2 mt-20 shadow-xl rounded-md bg-gray-100">
            <div className="text-center">
              <h2 className="text-lg font-bold text-gray-700">
                Reports not available !!
              </h2>
            </div>
          </div>
        )}
      </div>
    </>
  );
});

export default CategoryWiseSupplierSalesReport;
